export const CONTACT = {
  phoneDisplay: "+91 93618 56352",
  phoneHref: "tel:+919361856352",
  whatsappHref:
    "https://wa.me/919361856352?text=Hello%2C%20I%20need%20help%20with%20accounting%20services.",
  email: "growhighbookkeeping@gmail.com",
};
